import { NotifyType } from './../interfaces/notifyMessageModel';
import { Injectable, EventEmitter } from '@angular/core';
import { ApiService } from '../service/api.service';
import { SocketService } from '../service/socket.service';
import { NotifyMessageModel } from '../interfaces/notifyMessageModel';
import { UserStore } from './user.store';
import DateUtil from '../utils/dateUtil';
import { NativeNotificationService } from '../service/native-notification.service';
import { AcuStorageService } from '../service/acustorage.service';


@Injectable({
  providedIn: 'root'
})
export class NotifyStore {

  public notify: NotifyMessageModel[] = [];

  public storeUpdated: EventEmitter<void> = new EventEmitter();

  constructor(
    private socketService: SocketService,
    private apiService: ApiService,
    private userStore: UserStore,
    private nativeNotify: NativeNotificationService,
    private storage: AcuStorageService
  ) {
    this.initStore();
    this.socketService.receiveNotify().subscribe(async (msg: any) => {
      console.log('NotifyStore - received socket notify', msg);
      // L'evento arriva a tutti i client: si ignora quello indirizzato ad altri utenti
      if (!this.isForMe(msg)) return;
      // Il popup di sistema solo per le notifiche comparse ora, non per quelle già viste o appena lette
      const known = new Set(this.notify.map(n => this.idOf(n)));
      await this.initStore();
      const nuove = this.notify.filter(n => !known.has(this.idOf(n)));
      if (nuove.length > 0) {
        this.nativeNotify.showNotification('Acuplace: Nuova Notifica', {
          body: nuove.length === 1 ? nuove[0].message : `Hai ${nuove.length} nuove notifiche`,
          tag: 'acuplace-notify-' + this.idOf(nuove[0])
        });
      }
    });
    this.userStore.storeUpdated.subscribe(() => {
      if (this.userStore.userLogged) {
        this.initStore();
      }
    });
    this.socketService.updateStoreReconnected.subscribe(() => {
      console.log("updateStoreReconnected");
      if (this.userStore.userLogged) {
        this.initStore();
      }
    });
  }

  private idOf(n: NotifyMessageModel): string {
    return String(n._id || n.id);
  }

  /** Con destinatari indicati (singolo o elenco) l'evento interessa solo loro; senza, si aggiorna comunque. */
  private isForMe(msg: any): boolean {
    const me = this.userStore.userLogged;
    if (!me) return false;
    const myIds = [me.id, me._id].filter(Boolean).map(String);
    if (Array.isArray(msg?.receivers)) {
      return msg.receivers.map(String).some((id: string) => myIds.includes(id));
    }
    if (msg?.idUserReceiver) {
      return myIds.includes(String(msg.idUserReceiver));
    }
    return true;
  }

  public async initStore() {
    console.log('NotifyStore - initStore');
    if (!this.userStore.userLogged) return;
    try {
      const notifyResponse = await this.apiService.getNotifyToReadUser(this.userStore.userLogged.id || this.userStore.userLogged._id);
      this.notify = (notifyResponse || []).filter(n => {
        if (!n.dataValidita) return true;
        return DateUtil.isDateSameOrAfterToday(new Date(n.dataValidita));
      });
      this.storage.setObjectInStorage('allNotify', this.notify);
      this.storeUpdated.emit();
    } catch (error) {
      console.warn('NotifyStore - error fetching notifications, fallback to cached notifications', error);
      const cached = this.storage.getObjectInStorage<NotifyMessageModel[]>('allNotify');
      this.notify = cached || [];
      this.storeUpdated.emit();
    }
  }

  async insertNotify(notify: NotifyMessageModel) {
    try {
      await this.apiService.insertNotify(notify);
    } catch (error) {
      console.error('NotifyStore - error inserting notify:', error);
    }
    this.initStore();
  }

  async aggiornaNotify(notify: NotifyMessageModel) {
    try {
      await this.apiService.updateNotify(notify);
    } catch (error) {
      console.error('NotifyStore - error updating notify:', error);
    }
    this.initStore();
  }
}
